import { DateFields, Services, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { globalErrorHandler, projectName, request, states } from '@/utils'

import render from './render'

const order = [ [ DateFields.createdAt, OrderDirections.DESC ] ]
const pathToAPI = getServicePathToAPI(Services['otp-handler'])

export default {
  name: 'ThirdCol',

  /**
   * Локальное состояние третьей колонки виджета.
   *
   * Предел постраничного вывода читается из localStorage. Ошибка разбора
   * испорченного значения подавляется: в этом случае используется значение
   * по умолчанию.
   *
   * @returns {object} Локальное состояние колонки.
   */
  data() {
    let limit = 10
    try {
      const parsedLimit = JSON.parse(window.localStorage.getItem(`${projectName}:pagination:limit:${Services['otp-handler']}:request`))
      if (typeof parsedLimit === 'number') {
        limit = parsedLimit
      }
    } catch (error) {
    }

    return {
      tab: undefined,
      dialogTab: 'request',
      showDialog: false,

      state: states.empty,

      items: [],
      item: undefined,

      pagination: {
        limit,
        offset: 0,
        total: 0
      }
    }
  },

  computed: {
    widgetId() {
      return this.$route?.params?.id
    },

    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0
    },
    hasPermissions() {
      return this.checkPermissions(`advanced.${Services['otp-handler']}.get`)
    },

    tabs() {
      const result = []
      if (this.hasPermissions) {
        result.push('requests')
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    },
    dialogTabs() {
      const result = [ 'request', 'channels' ]

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    }
  },

  watch: {
    'pagination.offset'() {
      this.getItems()
    }
  },

  mounted() {
    this.tab = this.tabs[0]?.key
    this.getItems()
  },

  methods: {
    queryProcessor(query) {
      return {
        ...query,
        offset: this.pagination.offset,
        limit: this.pagination.limit,
        order
      }
    },

    async getItems() {
      if (this.widgetId && this.hasPermissions) {
        try {
          this.state = states.loading
          const data = await request.get(joinURLPath(pathToAPI, 'request'), undefined, this.queryProcessor({ widgetId: this.widgetId }))
          if (data?.data) {
            this.state = states.success
            this.items = data.data
            this.pagination.total = data.total
          }
        } catch (error) {
          this.state = states.error
          globalErrorHandler(error)
        } finally {
          this.state = states.ready
        }
      }
    }
  },

  render
}
